// Animation.js
import React, { useEffect } from 'react';
import "./Animation.css"; 

const Animation = () => {
  useEffect(() => {
    // Automatically redirect to main content after 3 seconds
    const timer = setTimeout(() => {
      // This will be handled by the Home component now
    }, 3000);

    // Cleanup timer on unmount
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <section id="animationfile">
      {/* Central Icon */}
      <div id="conternuc">
        <div className="nucleus">
          <img
            src="./webdpro.png"
            alt="Logo"
            style={{ width: "70px", height: "70px" }}
          />
        </div>
      </div>

      {/* Sector Icons as Electrons with enhanced glass effect */}
      <div className="electron-container">
        <div className="electron-glass">
          <button className="button">
            <div className="bloom-container">
              <div className="button-container-main">
                <div className="button-inner">
                  <div className="back"></div>
                  <div className="front">
                    <i className="fas fa-shopping-cart"></i>
                  </div>
                </div>
                <div className="button-glass">
                  <div className="back"></div>
                  <div className="front"></div>
                </div>
              </div>
              <div className="bloom bloom1"></div>
              <div className="bloom bloom2"></div>
            </div>
          </button>
          <span className="electron-label">E-commerce</span>
        </div>
        
        <div className="electron-glass">
          <button className="button">
            <div className="bloom-container">
              <div className="button-container-main">
                <div className="button-inner">
                  <div className="back"></div>
                  <div className="front">
                    <i className="fas fa-tshirt"></i>
                  </div>
                </div>
                <div className="button-glass">
                  <div className="back"></div>
                  <div className="front"></div>
                </div>
              </div>
              <div className="bloom bloom1"></div>
              <div className="bloom bloom2"></div>
            </div>
          </button>
          <span className="electron-label">Fashion</span>
        </div>
        
        <div className="electron-glass">
          <button className="button">
            <div className="bloom-container">
              <div className="button-container-main">
                <div className="button-inner">
                  <div className="back"></div>
                  <div className="front">
                    <i className="fas fa-car"></i>
                  </div>
                </div>
                <div className="button-glass">
                  <div className="back"></div>
                  <div className="front"></div>
                </div>
              </div>
              <div className="bloom bloom1"></div>
              <div className="bloom bloom2"></div>
            </div>
          </button>
          <span className="electron-label">Automobile</span>
        </div>
        
        <div className="electron-glass">
          <button className="button">
            <div className="bloom-container">
              <div className="button-container-main">
                <div className="button-inner">
                  <div className="back"></div>
                  <div className="front">
                    <i className="fas fa-hamburger"></i>
                  </div>
                </div>
                <div className="button-glass">
                  <div className="back"></div>
                  <div className="front"></div>
                </div>
              </div>
              <div className="bloom bloom1"></div>
              <div className="bloom bloom2"></div>
            </div>
          </button>
          <span className="electron-label">Food</span>
        </div>
        
        <div className="electron-glass">
          <button className="button">
            <div className="bloom-container">
              <div className="button-container-main">
                <div className="button-inner">
                  <div className="back"></div>
                  <div className="front">
                    <i className="fas fa-heartbeat"></i>
                  </div>
                </div>
                <div className="button-glass">
                  <div className="back"></div>
                  <div className="front"></div>
                </div>
              </div>
              <div className="bloom bloom1"></div>
              <div className="bloom bloom2"></div>
            </div>
          </button>
          <span className="electron-label">Healthcare</span>
        </div>
        
        <div className="electron-glass">
          <button className="button">
            <div className="bloom-container">
              <div className="button-container-main">
                <div className="button-inner">
                  <div className="back"></div>
                  <div className="front">
                    <i className="fas fa-film"></i>
                  </div>
                </div>
                <div className="button-glass">
                  <div className="back"></div>
                  <div className="front"></div>
                </div>
              </div>
              <div className="bloom bloom1"></div>
              <div className="bloom bloom2"></div>
            </div>
          </button>
          <span className="electron-label">Entertainment</span>
        </div>
        
        <div className="electron-glass">
          <button className="button">
            <div className="bloom-container">
              <div className="button-container-main">
                <div className="button-inner">
                  <div className="back"></div>
                  <div className="front">
                    <i className="fas fa-laptop"></i>
                  </div>
                </div>
                <div className="button-glass">
                  <div className="back"></div>
                  <div className="front"></div>
                </div>
              </div>
              <div className="bloom bloom1"></div>
              <div className="bloom bloom2"></div>
            </div>
          </button>
          <span className="electron-label">Electronics</span>
        </div>
        
        <div className="electron-glass">
          <button className="button">
            <div className="bloom-container">
              <div className="button-container-main">
                <div className="button-inner">
                  <div className="back"></div>
                  <div className="front">
                    <i className="fas fa-money-bill-wave"></i>
                  </div>
                </div>
                <div className="button-glass">
                  <div className="back"></div>
                  <div className="front"></div>
                </div>
              </div>
              <div className="bloom bloom1"></div>
              <div className="bloom bloom2"></div>
            </div>
          </button>
          <span className="electron-label">Finance</span>
        </div>
      </div>
    </section>
  );
};

export default Animation;